export default TextareaFocus = {
    mounted() {
        // document.querySelectorAll(".comment_icon").forEach((el) =>
        //     el.addEventListener("click", async (event) => {
        //         console.log("handling click");
        //         const id = el.getAttribute("data-post-id");
        //         event.preventDefault();
        //         event.stopImmediatePropagation();
        //         document.getElementById("comment_reply_wrapper").showModal();
        //         console.log(document.getElementById("comment_reply_wrapper"));
        // const w = document.getElementById("comment_reply_wrapper");
        // await liveSocket.execJS(w, w.getAttribute("data-show"));
        // window.visualViewport.addEventListener("resize", (event) => {
        //     event.preventDefault();
        //     event.stopImmediatePropagation();
        // });
        // const textarea = document.querySelector(
        //     "form#new_comment_form textarea#new_comment_text_area"
        // );
        // // console.log(textarea);
        // setTimeout(() => {
        //     console.log("focus text area now");
        //     textarea.focus({ preventScroll: true });
        // }, 5000);
        // })
        // );
    },
};
